import styled from 'styled-components'

export const CenteredContentArea = styled.div`
    display: flex;
    justify-content: center;
    padding-top: 3.75rem;
`
